<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
  import home from './api/motortime';
  export default {
    name: 'App',
    data () {
      return {
        list:[],
        menunum:1,
        wechatcode:false,
        ioscode:false,
        androidcode:false,
        appcodebk:false,
        loginshow:false,
        isMobile:false,
        isCode:false,
        isLogin:false,
        second:60,
        isgetCode:false,
        username:'',
        activeMenu:'Home',
        activePage:'',
        
        img:{
          logo: require('./assets/img/logo.png'),
          pc_logo: require('./assets/img/pc_logo.png'),
          appdownload: require('./assets/img/appdownload.png'),
          code_bk: require('./assets/img/code_bk.png'),
          android: require('./assets/img/android.png'),
          ios: require('./assets/img/ios.png'),
          wechat: require('./assets/img/wechat.png'),
          qrcode: require('./assets/img/qrcode.png'),
          close: require('./assets/img/close.png'),
          mobile: require('./assets/img/mobile.png'),
          code: require('./assets/img/code.png'),
          motortime: require('./assets/img/wechat/motortime.png'),
          lexus: require('./assets/img/wechat/lexus.png'),
          subaru: require('./assets/img/wechat/subaru.png'),
          vtec: require('./assets/img/wechat/vtec.png'),
          shop: require('./assets/img/wechat/shop.png'),
          topMobile: require('./assets/img/hoime_icon/mobile.png'),
          topWechat: require('./assets/img/hoime_icon/wechat.png'),
        }
      }
    },
    created () {
      // if(!localStorage.getItem('activePage')){
      //   this.activePage=0
      // }
      
      if(localStorage.getItem('userinfo')){
        var userinfo=JSON.parse(localStorage.getItem('userinfo'))
        this.isLogin=true
        this.username=userinfo.username
      }
      

    },
    methods: {

      selectMenu(name){
        this.activeMenu=name
        localStorage.setItem('activeMenu', name)
      },

      qrcodeShow(id){
        if(id==1){
          this.wechatcode=true
          this.ioscode=false
          this.androidcode=false
          this.appcodebk=true
        }else if(id==2){
          this.wechatcode=false
          this.ioscode=true
          this.androidcode=false
          this.appcodebk=true
        }else if(id==3){
          this.wechatcode=false
          this.ioscode=false
          this.androidcode=true
          this.appcodebk=true
        }
      },
      
      
    }
  }
</script>

<style lang="scss">
  .top_fiex{
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
  }
  .home_loading_box{
    margin:30px 0;
    text-align: center;
    img{
      width: 63px;
      height: 40px;
    }
  }
  .a_color{
    color: #6a6a6a;
  }
  .login_box{
    padding: 0 30px;
  }

  .display_flex{
    display: flex;
    align-items:center;
  }

  .flex_1{
    flex: 1;
  }
  .cursor_p{
    cursor: pointer;
  }
  .loginbox{
    width: 356px;
    height: 407px;
    position: fixed;
    z-index: 60001;    
    top:0;
    left:0;
    right:0;
    bottom:0;
    margin:auto;
    background: #fff;
    padding: 15px;

    .closepic{
      width: 12px;
      cursor: pointer;
    }
    .mobilepic{
      width: 14px;
      height: 22px;
    }
    .codepic{
      width: 17px;
      height: 19px;
    }
    .ivu-input{
      border: 0px;

    }
    .motorinput{
      margin-top: 30px;
      padding: 10px 0;
      border-bottom: 1px solid #dddddd;
    }
    .ivu-input-group-append,
    .ivu-input-group-prepend{
      background-color: #fff;
      border: 0px solid #dcdee2;
    }
    .ivu-input-group-append .ivu-btn{
      font-size: 12px;
    }
    .submitbtn{
      height: 40px;
      margin-top: 40px;
      border:0px;
      font-size: 18px;
    }
    .btn-gold{
      background:#F6AB00 !important;
      color: #fff !important;
      border:1px solid #F6AB00 !important;
    }
    .btn-gray{
      background:#F0F0F0 !important;
      color: #9A9A9A !important;
      border:1px solid #F0F0F0 !important;
    }
    .ivu-input:focus{
      outline:none;
      border:none;
      box-shadow: 0 0 0 2px transparent; 
    }
  }

  .copyali{
    border-top: 1px solid #4b5054;
    padding: 15px 0;
    border-bottom: 1px solid #4b5054;
  }
  .pt-20{
    padding-top:20px;
  }
  .logopic{
    width: 40px;
    height: 40px;
    vertical-align: middle;
  }
  .page_name_caca{
    background-color:#cacaca;
  }
  .pc_logo{
    height: 80px;
    width: 173px;
    margin-left: 1px;
    cursor:pointer;
  }
  .webname{
    font-size: 16px;
    font-weight: Medium;
    color: #F6AB01;
    margin-left: 10px;
    line-height: 40px;
  }
  .appdownload{
    width: 10px;
    height: 12px;
    margin-top: 8px;
  }

  .codebk{
    width: 50px;
    height: 55px;
    float: right;
    padding: 8px 2px 2px 2px;;
    background-repeat:no-repeat;
    background-size:100% 100%;
  }
  .wechat_box{
    padding:20px 20px 0 20px;
    .wechat_cell{
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .wechat_img{
        width: 66px;
        height: 66px;
        margin-right: 15px;
      }
      .wechat_des{
        color: #737171;
        font-size: 12px;
      }
    }
  }
  .ivu-menu-dark{
    background: transparent !important;
  }
  .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item, .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu{
    color: #000;
      // line-height: 40px;
    }
    .ivu-menu-horizontal .ivu-menu-item, .ivu-menu-horizontal .ivu-menu-submenu{
      padding:0 20px !important;
    }
    .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item-active, .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item:hover, .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu-active, .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu:hover{
      color: #F6AB01 !important;
      border-bottom:2px solid #F6AB01 !important;
    }
    .f-12{
      font-size: 12px;
    }
    .f-13{
      font-size: 13px;
    }
    .f-14{
      font-size: 14px;
    }
    .f-16{
      font-size: 16px;
    }
    .f-18{
      font-size: 18px;
    }
    .f-30{
      font-size: 30px;
    }
    .text-c{
      text-align: center;
    }
    .text-r{
      text-align: right;
    }
    .text-l{
      text-align: left;
    }
    .f-w{
      font-weight: bold;
    }
    .f-r{
      float: right;
    }
    .f-l{
      float: left;
    }
    .pd-10{
      padding: 10px;
    }
    .mt-5{
      margin-top: 5px;
    }
    .mt-10{
      margin-top: 10px;
    }
    .mt-15{
      margin-top: 15px;
    }
    .mt-20{
      margin-top: 20px;
    }
    .mt-25{
      margin-top: 25px;
    }
    .mt-30{
      margin-top: 30px;
    }
    .mt-40{
      margin-top: 40px;
    }
    .mt-50{
      margin-top: 50px;
    }
    .mb-5{
      margin-bottom: 5px;
    }
    .mb-10{
      margin-bottom: 10px;
    }
    .mb-15{
      margin-bottom: 15px;
    }
    .mb-20{
      margin-bottom: 20px;
    }
    .mb-25{
      margin-bottom: 25px;
    }
    .mb-30{
      margin-bottom: 30px;
    }
    .mb-40{
      margin-bottom: 40px;
    }
    .mb-50{
      margin-bottom: 50px;
    }
    .ml-5{
      margin-left: 5px;
    }
    .ml-10{
      margin-left: 10px;
    }
    .ml-15{
      margin-left: 15px;
    }
    .ml-20{
      margin-left: 20px;
    }
    .ml-25{
      margin-left: 25px;
    }
    .mr-5{
      margin-right: 5px;
    }
    .mr-10{
      margin-right: 10px;
    }
    .mr-15{
      margin-right: 15px;
    }
    .mr-20{
      margin-right: 20px;
    }
    .mr-25{
      margin-right: 25px;
    }
    .mr-30{
      margin-right: 30px;
    }
    .mr-40{
      margin-right: 40px;
    }
    .c-white{
      color: #FFFFFF;
    }
    .c-black{
      color: #3A3A3A;
    }
    .c-gray{
      color: #6A6A6A;
    }
    .c-gold{
      color: #F6AB00;
    }
    .c-red{
      color: red;
    }
    .ellipsis{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .ellipsis-2 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .ellipsis-3 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .ellipsis-4 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .footerbox{
      width: 100%;
      height: auto;
      background-color: #1C1D21;
      display: flex;
      justify-content: center;
      margin-top: 30px;
    }
    .footerinfo{
      width: 1200px;
      margin-top: 40px 0;
    }
    .uslist{
      color: #6A6A6A
    }
    .footeright{
      display: flex;
      float: right;
    }
    .rideosimg{ 
      width: 30px;
      height: 30px;
    }
    .gotop{
      width: 51px;
      height: 51px;
    }
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .loginoverlay{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.5;
      z-index: 60000;
      background-color: rgb(0, 0, 0); 
    }
    .appcodebk{
      width: 160px;
      height: 180px;
      transform: rotate(180deg);
      padding: 8px 2px 2px 2px;
      background-repeat:no-repeat;
      background-size:100% 100%;
    }
    .topapp_box{
      padding: 10px 5px 5px 5px;
      text-align: center;
      background-repeat:no-repeat;
      background-size:100% 100%;
    }
    .top_qrcode{
      width: 160px;
      height: 160px;
    }
    .ivu-poptip-body{
      padding: 0px 2px;
    }
    .ivu-poptip-popper{
      min-width: 50px;
    }
    .qrcode{
      width: 100%;
      height: 100%;
    }
    .uslist a{
      color: #6A6A6A;
    }
    .uslist a:hover{
      color: #FFFFFF;
    }
    iframe {
      width: 100%;
      height: 406px;
    }
    // 弹窗样式
    .wask_page{
      width: 100%;
      height: 100%;
      position:fixed;
      top: 0;
      bottom:0;
      background-color:rgba(0, 0, 0, 0.7);
      z-index: 1000;
      overflow-y:hidden;
    }
    .wask_qrcode{
      width: 280px;
      height: 350px;
      position: fixed;
      top: 25%;
      left: 44%;
      z-index: 1001;
      border-radius: 4px;
      text-align: center;
      color: #000000;
      font-size: 18px;
      background-size: 280px 350px;
    }
    .wask_qrcoded{
      width: 150px;
      position: fixed;
      right:30px;
      bottom: 12%;
      /*z-index: 1001;*/
      border-radius: 4px;
      text-align: center;
      color: #000000;
      font-size: 12px;
      background-size: 280px 350px;
      padding:15px;
    }
    .wechatqr{
      width: 150px;
      height: 150px;
      margin-top: 60px;
      border-radius: 300px;
    }
    .paymentqr{
      width: 150px;
      height: 150px;
      margin-top: 60px;
    }
    .wechatqrd{
      width: 120px;
      height: 120px;
      border-radius: 300px;
    }
    .more_comm{
      width: 500px;
      height: 50px;
      background-size: 500px 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #000000;
      margin-left: 26%;
    }
    .display_flex{
      display: flex;
      align-items:center;
    }
    h1{
      color: #3A3A3A;
    }
    .wask_qrcode_right{
     width: 150px;
     position: fixed;
     right:30px;
     bottom: 200px;
     border-radius: 4px;
     text-align: center;
     color: #000000;
   }
   .wask_qrcode_new{
    width: 200px;
    position: fixed;
    top: 25%;
    left: 44%;
    z-index: 1001;
    border-radius: 4px;
    text-align: center;
    color: #000000;
  }
  .wask_qrcode_top{
    padding:20px 12px;
    background-color:#FFB200;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    .wechatqr_new{
      width: 120px;
      height: 120px;
      border-radius:50%;
    }
  }
  .wask_qrcode_bottom{
    text-align: center;
    padding:15px 0 20px 0;
    background-color:#E5E5E5;
    border-bottom-left-radius:4px;
    border-bottom-right-radius:4px;
  }
  .wask_qrcode_triangle{
    width: 13px;
    height: 9px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue